export const ONBOARDING_TIMES_TABLE_THEAD_VALUES = [
  'start',
  'end',
  'day',
  'type',
  'actions',
]



// WEBPACK FOOTER //
// ./src/Containers/City/Page/OnboardingTimes/tableSettings.js